<template>
  <el-card shadow="always" v-if="state == 'CHANGED'">
    <div slot="header" class="clearfix">
      <span>Dados complementares do objeto</span>
      <el-button
        v-if="isJadlog && firstFormType === '001'"
        type="primary"
        size="small"
        style="float: right"
        @click="addNewEntry"
      >
        + Adicionar novo Volume
      </el-button>
    </div>
    <div>
      <div v-for="(form, index) in complementForms" :key="index">
        <div v-if="index > 0" class="entry-divider" style="clear: both">
          <el-divider>Pacote/Caixa {{ index + 1 }}</el-divider>
          <el-button
            type="danger"
            size="mini"
            class="remove-button"
            @click="removeEntry(index)"
          >
            Remover
          </el-button>
        </div>
        <div style="clear: both">
          <div :style="formContainerStyle">
            <el-form
              :ref="'form' + index"
              :model="form"
              :rules="rules"
              :label-position="labelPosition"
              label-width="180px"
            >
              <el-row :gutter="5" v-if="index === 0 && service && service.dce">
                <el-col :span="20">
                  <el-form-item prop="typeContent">
                    <el-radio v-model="form.typeContent" label="1" value="1">Com nota fiscal</el-radio
                    >
                    <el-radio v-model="form.typeContent" label="2"  value="2"
                      >Com DC-E</el-radio
                    >
                    <el-radio v-model="form.typeContent" label="3"  value="3"
                      >Emitir DC-E</el-radio
                    >
                    <el-radio v-model="form.typeContent" label="4"  value="4"
                      >Enviar NF-E posteriormente</el-radio
                    >
                    <el-radio v-model="form.typeContent" label="5"  value="5"
                      >Isento de DC-E</el-radio
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-if="form.typeContent === '1' && index === 0">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Chave NFE" prop="nfeKey">
                    <el-input
                      v-model="form.nfeKey"
                      placeholder="Digite a chave NFE"
                      maxlength="44"
                      @input="onNfeKeyInput(form, $event)"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Número da Nota" prop="nfeNumber" :required="nfeKeyFilled">
                    <el-input
                      v-model="form.nfeNumber"
                      placeholder="Número da nota"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-if="form.typeContent === '1' && index === 0">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Número de Série" prop="nfeSerie" :required="nfeKeyFilled">
                    <el-input
                      v-model="form.nfeSerie"
                      placeholder="Número de série"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Valor da Nota" prop="nfeValue" :required="nfeKeyFilled">
                    <el-input
                      v-model="form.nfeValue"
                      placeholder="Valor da nota fiscal"
                      type="number"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-if="form.typeContent === '2' && index === 0">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Código DC-E" prop="dceId">
                    <el-input
                      v-model="form.dceId"
                      placeholder="Digite o código da DC-E"
                      maxlength="44"
                      @input="onDceIdInput(form, $event)"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Número da Nota" prop="nfeNumber">
                    <el-input
                      v-model="form.nfeNumber"
                      placeholder="Preenchido pela DC-E"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-if="form.typeContent === '2' && index === 0">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Número de Série" prop="nfeSerie">
                    <el-input
                      v-model="form.nfeSerie"
                      placeholder="Preenchida pela DC-E"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item prop="nfeValue">
                    <template slot="label">
                      <span v-if="dceIdFilled" style="color: #f56c6c">*</span>
                      Valor da DC-E
                    </template>
                    <el-input
                      v-model="form.nfeValue"
                      placeholder="Valor da DC-E"
                      type="number"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-if="form.typeContent === '3' && index === 0">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-alert 
                    class="fs-14"
                    type="error" 
                    title="Ao emitir a DC-E você deverá informar a Declaração de Conteúdo no botão abaixo. A DC-E é um documento que substitui a nota fiscal e deve conter as informações da descrição do conteúdo, valor declarado e outras informações relevantes para a postagem."
                    :closable="false"
                  ></el-alert>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-if="form.typeContent === '4' && index === 0">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-alert 
                    class="fs-14"
                    type="error" 
                    title="Nesse caso a pre-posatagem ficará pendente e você poderá enviar a chave NF-E ou DC-E posteriormente."
                    :closable="false"
                  ></el-alert>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-if="form.typeContent === '5' && index === 0">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-alert 
                    class="fs-14"
                    type="info" 
                    title="A pré-postagem será enviada com o serviço adicional Isento de Documento Fiscal, sem nota fiscal e sem emissão de DC-E."
                    :closable="false"
                  ></el-alert>
                </el-col>
              </el-row>
              <el-divider>Pacote/Caixa</el-divider>
              <el-row :gutter="5" v-if="index === 0">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="20">
                  <el-form-item
                    class="no-margin-bottom"
                    :label="$t('tipo')"
                    prop="type"
                  >
                    <el-select
                      v-model="form.type"
                      placeholder="Selecione uma opção"
                      @change="() => handleTypeChange(index)"
                      style="width: 100%"
                    >
                      <el-option
                        key="003"
                        label="Envelope"
                        value="003"
                      ></el-option>
                      <el-option
                        key="001"
                        label="Pacote / Caixa"
                        value="001"
                      ></el-option>
                      <el-option
                        key="002"
                        label="Rolo / Cilindro / Esférico"
                        value="002"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-show="form.type === '001'">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="20">
                  <el-form-item
                    class="no-margin-bottom"
                    :label="$t('largura-cm')"
                    prop="length"
                  >
                    <el-slider
                      @change="() => handleDimensionChange(index)"
                      v-model="form.width"
                      :min="service ? +service.widthmin : 0"
                      :max="service ? +service.widthmax : 0"
                      show-input
                    >
                    </el-slider>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-show="form.type !== '003'">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="20">
                  <el-form-item
                    class="no-margin-bottom"
                    :label="$t('comprimento-cm')"
                    prop="width"
                  >
                    <el-slider
                      @change="() => handleDimensionChange(index)"
                      v-model="form.length"
                      :min="service ? +service.lengthmin : 0"
                      :max="service ? +service.lengthmax : 0"
                      show-input
                    >
                    </el-slider>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-show="form.type === '001'">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="20">
                  <el-form-item
                    class="no-margin-bottom"
                    :label="$t('altura-cm')"
                    prop="height"
                  >
                    <el-slider
                      @change="() => handleDimensionChange(index)"
                      v-model="form.height"
                      :min="service ? +service.heightmin : 0"
                      :max="service ? +service.heightmax : 0"
                      show-input
                    >
                    </el-slider>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-show="form.type === '002'">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="20">
                  <el-form-item
                    class="no-margin-bottom"
                    :label="$t('diametro')"
                    prop="diameter"
                  >
                    <el-slider
                      @change="() => handleDimensionChange(index)"
                      v-model="form.diameter"
                      :min="service ? +service.heightmin : 0"
                      :max="service ? +service.heightmax : 0"
                      show-input
                    >
                    </el-slider>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="5" v-if="index === 0">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="20">
                  <el-form-item
                    class="no-margin-bottom"
                    :label="$t('valor-declarado')"
                    prop="value"
                  >
                    <el-slider
                      @change="() => handleDimensionChange(index)"
                      v-model="form.value"
                      :min="service ? +service.valuemin : 0"
                      :max="maxValueDeclared"
                      :step="0.1"
                      show-input
                    >
                    </el-slider>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="hasNf && index === 0" :style="nfFormContainerStyle">
            <el-form :model="dataNf" label-position="top">
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom clearfix right" style="margin-bottom: 10px; clear: both">
      <el-button type="default" class="button" @click="dc"
        >Declaração de Conteúdo</el-button
      >
      <el-button type="primary" class="button" @click="confirm"
        >Adicionar pré-postagem</el-button
      >
    </div>
  </el-card>
</template>

<script>
export default {
  name: "PrePostComplement",
  props: ["state", "service", "package", "labelPosition"],
  computed: {
    maxValueDeclared() {
      console.log(this.complementForms)
      const form = this.complementForms[0] || this.getEmptyForm();
      if (this.service) {
        console.log(form.nfeKey, +this.service.valuemaxnf)
        return form.nfeKey || form.nfeNumber || +this.service.valuemaxnf == 0 ? +this.service.valuemax : +this.service.valuemaxnf;
      }
      return 0;
    },
    isJadlog() {
      return this.service && this.service.modalityCode;
    },
    nfeKeyFilled() {
      const form = this.complementForms && this.complementForms[0];
      if (!form || !form.nfeKey) return false;
      return String(form.nfeKey).replace(/\D/g, "").length === 44;
    },
    dceIdFilled() {
      const form = this.complementForms && this.complementForms[0];
      if (!form || !form.dceId) return false;
      return String(form.dceId).replace(/\D/g, "").length === 44;
    },
    isNextDayOrSameDay() {
      return this.service &&
        ['samedayexpress', 'sameday', 'nextday', 'nextdayhub'].includes(this.service.code);
    },
    complementForm() {
      return this.complementForms[0] || this.getEmptyForm();
    },
    firstFormType() {
      return (this.complementForms[0] && this.complementForms[0].type) || "";
    },
    formContainerStyle() {
      return {
        float: "left",
        width: this.hasNf ? "55%" : "100%",
        transition: "width 0.3s ease",
        marginBottom: "20px",
      };
    },
    nfFormContainerStyle() {
      return {
        float: "right",
        width: "40%",
        padding: "15px",
        transition: "width 0.3s ease",
        marginBottom: "20px",
        border: "solid 1px #e8ebe9",
        borderRadius: "3px",
        boxShadow: "3px  3px 5px #e8ebe9",
      };
    },
  },
  methods: {
    onNfeKeyInput(form, value) {
      const key = String(value || "").replace(/\D/g, "");
      if (key.length !== 44) return;
      if (!this.isValidNfeKey(key)) {
        this.$message.warning("Chave NF-e inválida (DV não confere)");
        return;
      }
      // Só preenche se estiver vazio — não sobrescreve digitação manual
      if (!form.nfeSerie) {
        form.nfeSerie = String(parseInt(key.substr(22, 3), 10));
      }
      if (!form.nfeNumber) {
        form.nfeNumber = String(parseInt(key.substr(25, 9), 10));
      }
    },
    onDceIdInput(form, value) {
      const code = String(value || "").replace(/\D/g, "");
      if (code.length !== 44) return;
      if (!this.isValidNfeKey(code)) {
        this.$message.warning("Código DC-E inválido (DV não confere)");
        return;
      }
      // Campos disabled — sempre sobrescreve, único caminho de preenchimento
      form.nfeSerie = String(parseInt(code.substr(22, 3), 10));
      form.nfeNumber = String(parseInt(code.substr(25, 9), 10));
    },
    isValidNfeKey(key) {
      if (!/^\d{44}$/.test(key)) return false;
      const body = key.substr(0, 43);
      const dv = parseInt(key.charAt(43), 10);
      let sum = 0;
      let weight = 2;
      for (let i = body.length - 1; i >= 0; i--) {
        sum += parseInt(body.charAt(i), 10) * weight;
        weight = weight === 9 ? 2 : weight + 1;
      }
      const mod = sum % 11;
      const calc = mod < 2 ? 0 : 11 - mod;
      return calc === dv;
    },
    reset() {
      this.complementForms = [this.getEmptyForm()];
      this.dataNf = {
        nfeKey: "",
        nfeNumber: "",
        nfeSerie: "",
      };
      this.hasNf = false;
      this.loading = false;
      this.dialog = false;
      this.items = [];
      this.calcTotal();
    },
    handleNfChange() {
      this.hasNf = !this.hasNf;
    },
    getEmptyForm() {
      console.log('getEmptyForm', this)
      return {
        value: 0,
        height: 0,
        length: 0,
        width: 0,
        diameter: 0,
        type: "001",
        typeContent: "1",
        nfeKey: "",
        nfeNumber: "",
        nfeSerie: "",
        nfeValue: "",
        dceId: "",
      };
    },
    addNewEntry() {
      if (this.firstFormType === "001") {
        const newForm = this.getEmptyForm();
        newForm.type = "001"; // Force type to be 001 for additional forms
        this.complementForms.push(newForm);
      }
    },
    removeEntry(index) {
      this.complementForms.splice(index, 1);
      this.handleDimensionChange(0);
    },
    handleTypeChange(index) {
      if (index === 0) {
        const newType = this.complementForms[0].type;
        if (newType !== "001") {
          this.complementForms = [this.complementForms[0]];
        }
        this.calcTotal();
      }
    },
    handleDimensionChange(index) {
      this.calcTotal();
    },
    confirm() {
      const vm = this;

      // Validate the first form (which contains the declared value)
      const formRef = vm.$refs['form0'];
      if (formRef && formRef[0]) {
        formRef[0].validate((valid) => {
          if (valid) {
            const dataToEmit = this.isJadlog
              ? this.complementForms
              : this.complementForm;
            vm.$emit("confirm", dataToEmit);
          } else {
            vm.$message.error('Corrija os erros no formulário antes de continuar.');
            return false;
          }
        });
      } else {
        // If no form ref, proceed as before
        const dataToEmit = this.isJadlog
          ? this.complementForms
          : this.complementForm;
        vm.$emit("confirm", dataToEmit);
      }
    },
    changed() {
      const vm = this;
      vm.$emit("changed");
    },
    saved(list) {
      const vm = this;
      vm.$emit("saved", list);
    },
    dc() {
      const vm = this;
      vm.$emit("open");
    },
    calcTotal() {
      const vm = this;
      vm.$emit("calcTotal");
    },
  },
  watch: {
    hasNf: {
      // deep: true,
      handler(forms) {
        for (const form of forms) {
          this.calcTotal();
          form._oldValue = { ...form };
        }
      },
    },
    state: function (v) {
      const vm = this;
    },
    package: function (after, before) {},
    "complementForms.0.typeContent": function (newVal, oldVal) {
      if (newVal === oldVal) return;
      const form = this.complementForms[0];
      if (!form) return;
      form.nfeKey = "";
      form.nfeNumber = "";
      form.nfeSerie = "";
      form.nfeValue = "";
      form.dceId = "";
    },
  },
  mounted() {
    const vm = this;
    setTimeout(() => {
        console.log('mounted', vm.service)
      if (vm.package && vm.service) {
        vm.complementForms[0].height =
          vm.package.height > 0 ? vm.package.height : +vm.service.heightmin;
        vm.complementForms[0].length =
          vm.package.length > 0 ? vm.package.length : +vm.service.lengthmin;
        vm.complementForms[0].width =
          vm.package.width > 0 ? vm.package.width : +vm.service.widthmin;
      }
    }, 500);
  },
  data() {
    const validateDeclaredValue = (rule, value, callback) => {
      if (this.isNextDayOrSameDay && (!value || value <= 0)) {
        callback(new Error('Para este serviço é obrigatório informar um valor declarado'));
      } else {
        callback();
      }
    };

    const validateNfeKey = (rule, value, callback) => {
      const key = String(value || "").replace(/\D/g, "");
      if (!key) return callback();
      if (key.length !== 44) {
        return callback(new Error("Chave NF-e deve ter 44 dígitos"));
      }
      if (!this.isValidNfeKey(key)) {
        return callback(new Error("Chave NF-e inválida (DV não confere)"));
      }
      callback();
    };

    const validateDceId = (rule, value, callback) => {
      const code = String(value || "").replace(/\D/g, "");
      if (!code) return callback();
      if (code.length !== 44) {
        return callback(new Error("Código DC-E deve ter 44 dígitos"));
      }
      if (!this.isValidNfeKey(code)) {
        return callback(new Error("Código DC-E inválido (DV não confere)"));
      }
      callback();
    };

    const requireWhenNfeKeyFilled = (label) => (rule, value, callback) => {
      if (!this.nfeKeyFilled) return callback();
      const isEmpty =
        value === "" ||
        value === null ||
        value === undefined ||
        Number(value) === 0;
      if (isEmpty) {
        return callback(new Error(`${label} é obrigatório quando a chave NF-e está preenchida`));
      }
      callback();
    };

    const requireValueWhenAnyKeyFilled = (rule, value, callback) => {
      if (!this.nfeKeyFilled && !this.dceIdFilled) return callback();
      const isEmpty =
        value === "" ||
        value === null ||
        value === undefined ||
        Number(value) === 0;
      if (isEmpty) {
        const fieldLabel = this.dceIdFilled ? "Valor da DC-E" : "Valor da Nota";
        const source = this.dceIdFilled ? "o código DC-E" : "a chave NF-e";
        const sourceVerb = this.dceIdFilled ? "está preenchido" : "está preenchida";
        return callback(new Error(`${fieldLabel} é obrigatório quando ${source} ${sourceVerb}`));
      }
      callback();
    };

    return {
      loading: false,
      dialog: false,
      items: [],
      complementForms: [this.getEmptyForm()],
      hasNf: this.hasNf,
      typeContent: "1",
      content: {
        nfeKey: "",
        nfeNumber: "",
        nfeSerie: "",
        dceId: "",
      },
      dataNf: {
        nfeKey: "",
        nfeNumber: "",
        nfeSerie: "",
      },
      rules: {
        value: [
          { validator: validateDeclaredValue, trigger: 'change' }
        ],
        nfeKey: [
          { validator: validateNfeKey, trigger: 'blur' }
        ],
        dceId: [
          { validator: validateDceId, trigger: 'blur' }
        ],
        nfeNumber: [
          { validator: requireWhenNfeKeyFilled('Número da Nota'), trigger: 'blur' }
        ],
        nfeSerie: [
          { validator: requireWhenNfeKeyFilled('Número de Série'), trigger: 'blur' }
        ],
        nfeValue: [
          { validator: requireValueWhenAnyKeyFilled, trigger: 'blur' }
        ]
      }
    };
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  :deep(.el-form) {
    width: 100% !important;
    float: none !important;
  }

  div[style*="float:right"],
  div[style*="float:left"] {
    width: 100% !important;
    float: none !important;
  }
}

.entry-divider {
  margin: 20px 0;
  position: relative;
}

.remove-button {
  float: right;
  right: 0 !important;
  top: 5px !important;
}

/* Add this to ensure el-row doesn't interfere */
.el-row {
  position: relative;
  z-index: 1;
}
.fs-14 :deep(.el-alert__title)  {
  font-size: 14px;
}
</style>